import * as actions from '../actions/actions'

const initialState = {
  loading: false
}

export default function progress(state = initialState, action) {
  switch(action.type) {
    case actions.PROGRESS_START:
      return progressStart(state, action);
    case actions.PROGRESS_STOP:
      return progressStop(state, action);
    default:
      return state
  }
}

const progressStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const progressStop = (state, action) => {
  return {
    ...state,
    loading: false
  }
}